export default "__VITE_ASSET__BWJJ5CMJ__"